import {Stack, Box, useTheme} from "@mui/material";
import {ProductStack} from "../../components/marketing/Products/ProductStack";
import React from "react";
import {selectProductCardPropsByIds} from "../../components/marketing/Products/productCatalogAdapter";
import {CervinoHeaderText} from "../../components/typography/CervinoHeaderText";

const RICE_CUPS_PRODUCTS_IDS = [
    "rice_cup_mexican_homestyle",
    "rice_cup_mexican_pollo_asado",
    "rice_cup_street_corn",
    "rice_cup_peppers_chipotle",
    "rice_cup_poblano",
];

const RICE_POUCHES_PRODUCTS_IDS = [
    "rice_pouch_mexican_homestyle",
    "rice_pouch_mexican_pollo_asado",
    "rice_pouch_mexican_street_corn",
    "rice_pouch_peppers_chipotle",
    "rice_pouch_poblano",
];

export default function RicesSection() {
    const theme = useTheme();
    const riceCups = selectProductCardPropsByIds(RICE_CUPS_PRODUCTS_IDS);
    const ricePouches = selectProductCardPropsByIds(RICE_POUCHES_PRODUCTS_IDS);

    return (
        <Stack spacing={2} sx={{ width: "100%" }}>
            <CervinoHeaderText
                sx={{fontSize: { xs: "1.8rem", sm: "3rem", md: "4rem", lg: "5rem", xl: "6rem" }}}
                color={theme.palette.primary.main}
            >
                CUPS
            </CervinoHeaderText>

            <Box
                sx={{
                    width: "100%",
                    px: { xs: 2, sm: 3, md: 2, lg: 2, xl: 1 },
                    mx: "auto",
                }}
            >
                <ProductStack products={riceCups} />
            </Box>

            <CervinoHeaderText sx={{fontSize: { xs: "1.8rem", sm: "3rem", md: "4rem", lg: "5rem", xl: "6rem" }}}
                               color={theme.palette.primary.main}>POUCHES</CervinoHeaderText>

            <Box
                sx={{
                    width: "100%",
                    px: { xs: 2, sm: 3, md: 2, lg: 2, xl: 1 },
                    mx: "auto",
                }}
            >
                <ProductStack products={ricePouches} />
            </Box>

        </Stack>
    );
}
